import { useTranslation } from "react-i18next";
import { useState, useContext, useEffect } from 'react';
import { toast } from "react-toastify";

//icons
import { GoSync } from 'react-icons/go';

//components
import VerificationInput from "react-verification-input";
import { Col, Spinner, Stack } from 'react-bootstrap';
import SystemContext from "../../../../../context/systemContext/context";
import logo from "../../../../../assets/img/logo.svg";
import logoWhite from "../../../../../assets/img/logo-white.svg";

import { VerifyCodeProps } from "../../../../@types";
import { CREATE_ACCOUNT_STEPS } from "../../../../@enums";

//service
import { createUser, verifyActivationCode, sendActivationCode } from "../../../../services/create-account/create-account.service";

export const VerifyCode = ({user, setStep}: VerifyCodeProps): JSX.Element => {
  const { systemConfig } = useContext(SystemContext)
  const { t: translation } = useTranslation();
  const [loading, setLoading] = useState<boolean>(true);
  const [loadingButton, setLoadingButton] = useState<boolean>(false);
  const [seconds, setSeconds] = useState<number>(40);
  const [code, setCode] = useState<string>("");
  const [emailObscured, setEmailObscured] = useState<string>();

  const handleResendCode = (e: any) => {
    e.preventDefault();

    sendActivationCode(user.email, user.name).then(() => {
      setStep(CREATE_ACCOUNT_STEPS.verifyCode);
    }).catch(() => {
      toast.error('Ocorreu um erro ao enviar o código de verificação')
    });

    setSeconds(40);
  }

  const handleSubmit = () => {
    setLoadingButton(true);
    verifyActivationCode(code, user.email).then(() => {
      createUser(user).then(() => {
        toast.success('Usuário criado com sucesso!')
        setLoadingButton(false);
        setStep(CREATE_ACCOUNT_STEPS.finishRegister)
      }).catch(() => {
        toast.error('Ocorreu um erro ao criar seu usuário!')
        setLoadingButton(false);
      })
    }).catch(() => {
      toast.error('Código de verificação inválido! Verifique o código e digite novamente.')
      setLoadingButton(false);
    })    
  }

  const obscureEmail = (email: string) => {
    const [name, domain] = email.split('@');
    return `${name[0] + name[1]}${new Array(name.length).join('*')}@${domain}`;
  };

  useEffect(() => {
    if (seconds > 0) {
      setTimeout(() => {
        setSeconds(seconds - 1)
      }, 1000)
    }
  }, [seconds])

  useEffect(() => {
    setEmailObscured(obscureEmail(user.email));
    setLoading(false)
  }, [])

  useEffect(() => {
    if (code && code.length === 6) {
      handleSubmit();
    }
  }, [code])

  if (loading) {
    return(
      <div className="loading-container">
        <Spinner animation="border" variant="primary" />
      </div>
    )
  }

  return (
    <div className="w-100">
      <Col className="text-center mb-2rem">
        { systemConfig.theme === "light" ? (<img src={logo} alt="Logo" height={65} />) : (<img src={logoWhite} alt="Logo" height={65} />) }
      </Col>
      <Col className="text-center mb-2rem">
        <p className="text-black text-center mb-0" style={{ fontSize: '16px' }}><b>{translation('login.descriptionTypeCode')} {emailObscured}</b></p>
        <p className="text-dark-grey text-center mt-3 mb-0" style={{ fontSize: '14px' }}>{translation('login.spamMessage')}</p>
        <p className="text-dark-grey text-center mb-0" style={{ fontSize: '14px' }}>{translation('login.verifySpamMessage')}</p>
      </Col>
      <Col className="d-flex justify-content-center mb-3">
        <VerificationInput placeholder="" length={6} onChange={(e: any) => setCode(e.toUpperCase())} 
          removeDefaultStyles
          classNames={{
            container: "container-code",
            character: "character",
            characterInactive: "character--inactive",
            characterSelected: "character--selected",
          }}
        />
      </Col>
      <Col className="text-center mb-3">
        {
          seconds > 0 ? (
            <>
              <GoSync className="resend-code" /> {seconds}s {translation('login.resendCode')}
            </>
          ) : (
            <a href="#" onClick={(e: any) => handleResendCode(e)}>{translation('login.resendCode')}</a>
          )
        }
      </Col>
        {
          loadingButton &&
          <Stack gap={4} className="col-8 mx-auto mt-3 d-flex align-items-center">
            <Spinner animation="border" variant="primary" />
          </Stack>
        }
    </div>
  )
}